<template>
  <div class="modal" v-if="modalShown" v-drag="{handle:'#modal-moving'}" style="position: fixed">
    <div class="modal-main faceoption-modal">
      <div class="title-area" id="modal-moving">
        <h2>加工データ</h2>
      </div>
      <!-- ローディングモーダル -->
      <dd-loading-modal ref="loadingModalRef" />
      <div class="data-area" v-if="!isSetProcess">
        <ul>
          <li>
            <span>{{ spaceObjName + '（ID:' + focusedMenuSpace.id + '）'}}</span>
          </li>
            <li>
            <button type="button" class="main_btn" @click="showAddModal">追加登録</button>
            </li>
          <li>
            <label>加工選択：</label>
            <select class="select-process" v-model="form.pdId" @change="onPreview">
              <option v-for="(process, index) in processList" :key="index" :value="process.pdId">
                {{ process.pdOwnFaceType + ' / ' + process.pdOriginal + ' / x:' + process.pdX + ' y:' + process.pdY }}
              </option>
            </select>
            <button type="button" class="main_btn" @click="showEditModal(form.pdId)">編集</button>
            <button type="button" class="main_btn" @click="confirmDelete">削除</button>
          </li>
          <li>
            <div class="error_messages">
              <div class="error_message">{{ errorMessage.text }}</div>
            </div>
          </li>
        </ul>
      </div>
      <div class="main-area">
        <div class="data-area" v-if="isSetProcess">
          <ul>
            <li>
              <span>{{ spaceObjName + '（ID:' + focusedMenuSpace.id + '）'}}</span>
            </li>
            <li>
              <div class="label">基準面</div>
              <div class="input">
                <label v-if="dirAtt.attValue1 === 2"><input type="radio" v-model="form.faceType" :value="1">右面</label>
                <label v-if="dirAtt.attValue1 === 2"><input type="radio" v-model="form.faceType" :value="2">左面</label>
                <label v-if="dirAtt.attValue1 === 1"><input type="radio" v-model="form.faceType" :value="3">上面</label>
                <label v-if="dirAtt.attValue1 === 1"><input type="radio" v-model="form.faceType" :value="4">下面</label>
                <label v-if="dirAtt.attValue1 === 3"><input type="radio" v-model="form.faceType" :value="5">前面</label>
                <label v-if="dirAtt.attValue1 === 3"><input type="radio" v-model="form.faceType" :value="6">背面</label>
              </div>
            </li>
            <li>
              <div class="label">加工種類</div>
              <div class="input">
                <select v-model="form.processId">
                  <option v-for="(process, index) in processMasterList" :key="index" :value="process.processId">{{ process.processName }}</option>
                </select>
              </div>
            </li>
            <li>
              <div class="label">基準点</div>
              <div class="input">
                <select v-model="form.cornerType">
                  <option v-for="(corner, index) in cornerTypeList" :key="index" :value="corner.value">{{ corner.name }}</option>
                </select>
              </div>
            </li>
            <li>
              <div class="label">加工位置</div>
              <div class="input">
                <div class="input-size">
                  <span>x:</span>
                  <input type="number" v-if="selectedProcess" v-model="selectedProcess.pdX">
                  <input type="number" v-else v-model="form.pdX">
                </div>
                <div class="input-size">
                  <span>y:</span>
                  <input type="number" v-if="selectedProcess" v-model="selectedProcess.pdY">
                  <input type="number" v-else v-model="form.pdY">
                </div>
              </div>
            </li>
            <li>
              <div class="label">加工サイズ</div>
              <div class="input">
                <div class="input-size">
                  <span>w:</span>
                  <input type="number" v-if="selectedProcess" v-model="selectedProcess.pdW">
                  <input type="number" v-else v-model="form.pdW">
                </div>
                <div class="input-size">
                  <span>h:</span>
                  <input type="number" v-if="selectedProcess" v-model="selectedProcess.pdH">
                  <input type="number" v-else v-model="form.pdH">
                </div>
                <div class="input-size">
                  <span>d:</span>
                  <input type="number" v-if="selectedProcess" v-model="selectedProcess.pdD" :disabled="isThroughProcess">
                  <input type="number" v-else v-model="form.pdD" :disabled="isThroughProcess">
                  <div class="check"><span>貫通</span><input type="checkbox" v-model="isThroughProcess"></div>
                </div>
              </div>
            </li>
            <li>
              <div class="label">角R</div>
              <div class="input">
                <input type="number" v-if="selectedProcess" v-model="selectedProcess.processR" :disabled="processType != 2">
                <input type="number" v-else v-model="form.processR" :disabled="processType != 2">
              </div>
            </li>
          </ul>
        </div>
        <div class="preview-area">
          <div class="face-area">
            <svg :width="this.svgSize" :height="this.svgSize" :viewBox="dispViewBox">
              <g>
               <text :x="textPreviewData.sizeW.x" :y="textPreviewData.sizeW.y" text-anchor="middle" :font-size="fontSize">
                 {{textPreviewData.sizeW.size}}
                </text>
               <text :x="textPreviewData.sizeH.x" :y="textPreviewData.sizeH.y" dominant-baseline="central" :font-size="fontSize">
                 {{textPreviewData.sizeH.size}}
                </text>
              </g>
              <rect
                v-if="isShowSpace"
                :x="(svgSize-previewData.width) / 2"
                :y="(svgSize-previewData.height) / 2"
                :width="previewData.width"
                :height="previewData.height"
                stroke="black"
                fill="white"
              />
              <rect
                v-if="isShowProcess && isShowFirstFace"
                :x="(svgSize-previewData.width) / 2 + previewData.processX - previewData.processW / 2"
                :y="(svgSize-previewData.height) / 2 + previewData.processY - previewData.processH / 2"
                :rx="previewData.processRX"
                :ry="previewData.processRY"
                :width="previewData.processW"
                :height="previewData.processH"
                stroke="red"
                fill="white"
                stroke-width="2"
              />
            </svg>
            <div class="face-name">
              <span>{{ firstFace.name }}</span>
            </div>
          </div>
          <div class="face-area">
            <svg :width="this.svgSize" :height="this.svgSize" :viewBox="dispViewBox">
              <g>
               <text :x="textPreviewData.sizeW.x" :y="textPreviewData.sizeW.y" text-anchor="middle" :font-size="fontSize">
                 {{textPreviewData.sizeW.size}}
                </text>
               <text :x="textPreviewData.sizeH.x" :y="textPreviewData.sizeH.y" dominant-baseline="central" :font-size="fontSize">
                 {{textPreviewData.sizeH.size}}
                </text>
              </g>
              <rect
                v-if="isShowSpace"
                :x="(svgSize-previewData.width)/2"
                :y="(svgSize-previewData.height)/2"
                :width="previewData.width"
                :height="previewData.height"
                stroke="black"
                fill="white"
              />
              <rect
                v-if="isShowProcess && isShowSecondFace"
                :x="(svgSize-previewData.width) / 2 + previewData.processX - previewData.processW / 2"
                :y="(svgSize-previewData.height) / 2 + previewData.processY - previewData.processH / 2"
                :rx="previewData.processRX"
                :ry="previewData.processRY"
                :width="previewData.processW"
                :height="previewData.processH"
                stroke="red"
                fill="white"
                stroke-width="2"
              />
            </svg>
            <div class="face-name">
              <span>{{ secondFace.name }}</span>
            </div>
          </div>
        </div>
        <div class="errormessage-area">
          <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['faceType'] }}</p>
          <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['processId'] }}</p>
          <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['cornerType'] }}</p>
          <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['pdX'] }}</p>
          <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['pdY'] }}</p>
          <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['pdW'] }}</p>
          <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['pdH'] }}</p>
          <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['pdD'] }}</p>
        </div>
      </div>
      <div class="button-area">
        <button type="button" class="main_btn" v-if="isSetProcess && !selectedProcess" @click="updateProcess">登録</button>
        <button type="button" class="main_btn" v-if="isSetProcess && selectedProcess" @click="updateProcess">更新</button>
        <button type="button" class="main_btn" v-if="isSetProcess" @click="onCancelEdit">戻る</button>
        <button type="button" class="main_btn" v-if="!isSetProcess" @click="onCancel">閉じる</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import {API_URL} from '../../../constants/App'
import {ATTRIBUTE_KEY, CORNER_TYPE, FACE_TYPE} from '../../../constants/Type'
import * as Api from '../../../utils/Api'
import * as AppUtil from '../../../utils/App'
import * as SpaceUtil from '../../../utils/Space'
import LoadingModal from '../../common/LoadingModal'

export default {
  name: 'FaceOptionModal',
  components: {
    'dd-loading-modal': LoadingModal
  },
  props: {
    fileData: Object,
    /** 編集操作用空間データ */
    editCtrlSpaces: Array,
    focusedMenuSpace: Object
  },
  data () {
    return {
      modalShown: false,
      isSetProcess: false,
      isDeleteProcess: false,
      isThroughProcess: false,
      /** 加工情報 */
      form: {
        pdOwnSpId: '',
        pdId: '',
        faceType: '',
        processId: '',
        cornerType: '',
        pdX: 0,
        pdY: 0,
        pdZ: 0,
        pdW: 0,
        pdH: 0,
        pdD: 0,
        processR: 0
      },
      /** 選択空間 */
      selectedSpace: {},
      /** 選択空間オブジェクト名 */
      spaceObjName: '',
      /** アトリビュート情報 */
      dirAtt: {},
      /** 加工マスター一覧 */
      processMasterList: [],
      /** 既存加工一覧 */
      processList: [],
      /** 頂点一覧 */
      cornerTypeList: [
        {
          value: 1,
          name: '左下'
        },
        {
          value: 2,
          name: '右下'
        },
        {
          value: 3,
          name: '右上'
        },
        {
          value: 4,
          name: '左上'
        },
        {
          value: 5,
          name: '下中'
        },
        {
          value: 6,
          name: '右中'
        },
        {
          value: 7,
          name: '上中'
        },
        {
          value: 8,
          name: '左中'
        },
        {
          value: 9,
          name: '中心'
        }
      ],
      /** プレビュー表示用データ */
      previewData: {
        width: '',
        height: '',
        processX: '',
        processY: '',
        processRX: '',
        processRY: '',
        processW: '',
        processH: ''
      },
      textPreviewData: {
        sizeW: {
          size: '',
          x: '',
          y: ''
        },
        sizeH: {
          size: '',
          x: '',
          y: ''
        }
      },
      /** プレビュー表示エリアサイズ */
      svgSize: 350,
      /** プレビュー縮尺率 */
      previewRatio: 1,
      /** 加工の最小表示サイズ */
      minPreviewProcessSize: 2,
      /** フォントサイズ */
      fontSize: 13,
      /** 表示対象面 */
      firstFace: {
        name: '',
        code: ''
      },
      secondFace: {
        name: '',
        code: ''
      },
      /** エラーメッセージ */
      errorMessage: { text: '' },
      validateErrorMessages: {}
    }
  },
  computed: {
    selectedProcess: function () {
      if (this.processList === null) return null
      return this.processList.filter(process => process.pdId === this.form.pdId)[0]
    },
    processType: function () {
      return this.selectedProcess && !this.isSetProcess ? this.processMasterList.filter(process => process.processId === this.selectedProcess.processId)[0].processType
        : this.form.processId ? this.processMasterList.filter(process => process.processId === this.form.processId)[0].processType
          : 0
    },
    isShowFirstFace: function () {
      return [1, 3, 5].includes(this.form.faceType)
    },
    isShowSecondFace: function () {
      return [2, 4, 6].includes(this.form.faceType)
    },
    isShowSpace: function () {
      return this.selectedSpace !== null
    },
    isShowProcess: function () {
      return !isNaN(this.previewData.processX) && !isNaN(this.previewData.processY) && !isNaN(this.previewData.processW)
    },
    dispViewBox: function () {
      return 0 + ' ' + 0 + ' ' + this.svgSize + ' ' + this.svgSize
    }
  },
  watch: {
    modalShown: function () {
      /** キャンバス内キーボード制御 */
      if (this.modalShown) {
        this.$emit('onShowModal')
        document.addEventListener('keydown', this.onKeydown)
      } else {
        this.$emit('onCloseModal')
        document.removeEventListener('keydown', this.onKeydown)
      }
    },
    selectedProcess: {
      handler: function () {
        this.onPreview()
      },
      deep: true
    },
    form: {
      handler: function () {
        this.onPreview()
      },
      deep: true
    },
    isThroughProcess: function () {
      if (this.isThroughProcess) {
        if (this.selectedProcess) {
          this.selectedProcess.pdD = ''
        } else {
          this.form.pdD = ''
        }
      } else {
        if (this.selectedProcess) {
          this.selectedProcess.pdD = 0
        } else {
          this.form.pdD = 0
        }
      }
    }
  },
  methods: {
    /** 加工モーダル表示 */
    showModal: function () {
      this.clearData()
      this.form.pdOwnSpId = this.focusedMenuSpace.id
      this.getProcessMaster()
      this.getProcessData()
      this.showPartsPreview()
      this.isSetProcess = false
      this.modalShown = true
    },
    /** 追加モーダル表示 */
    showAddModal: function () {
      this.clearData()
      this.form.pdOwnSpId = this.focusedMenuSpace.id
      this.form.faceType = 1
      this.form.cornerType = 1
      let cutoutMaster = this.processMasterList.filter(process => process.processType === 2)
      this.form.processId = cutoutMaster[0].processId
      switch (this.dirAtt.attValue1) {
        case 1:
          this.form.faceType = 3
          break
        case 2:
          this.form.faceType = 1
          break
        case 3:
          this.form.faceType = 5
          break
      }
      this.isSetProcess = true
    },
    /** 編集モーダル表示 */
    showEditModal: function (id) {
      if (isNaN(this.form.pdId) || this.form.pdId === '') {
        this.errorMessage.text = '加工を選択してください'
        return
      }
      this.clearData()
      this.form.pdOwnSpId = this.focusedMenuSpace.id
      this.form.pdId = id
      this.form.processId = this.selectedProcess.processId
      this.form.cornerType = Object.keys(CORNER_TYPE)
        .filter(data => CORNER_TYPE[data].label === this.selectedProcess.pdOriginal)
        .map(data => { return CORNER_TYPE[data].code })[0]
      this.form.faceType = this.getfaceTypeCode(this.selectedProcess.pdOwnFaceType)
      if (this.selectedProcess.pdD < 0) {
        this.isThroughProcess = true
      }
      this.isSetProcess = true
    },
    /** モーダルキャンセル */
    onCancel: function () {
      this.$emit('closeTreeContextModal')
      this.modalShown = false
    },
    /** 編集キャンセル */
    onCancelEdit: function () {
      this.clearData()
      if (this.processList.length > 0) {
        this.form.pdId = this.processList[0].pdId
      }
      this.isSetProcess = false
    },
    /** 加工マスター取得 */
    getProcessMaster: function () {
      axios.get(API_URL.PLANNING + '/process')
        .then(response => {
          this.processMasterList = response.data.data
          this.$refs.loadingModalRef.showModal(false)
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error)
        })
    },
    /** 既存加工情報取得 */
    getProcessData: function () {
      axios.get(API_URL.PLANNING + '/process/' + this.focusedMenuSpace.id)
        .then(response => {
          // 表示対象面の加工のみリストへ
          this.processList = response.data.data.filter(process =>
            this.firstFace.code === this.getfaceTypeCode(process.pdOwnFaceType) ||
            this.secondFace.code === this.getfaceTypeCode(process.pdOwnFaceType)
          )
          if (this.processList.length > 0) {
            this.form.pdId = this.processList[0].pdId
          }
          this.$refs.loadingModalRef.showModal(false)
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error)
        })
      this.getPartsData()
    },
    /** パーツ情報の取得 */
    getPartsData: function () {
      this.selectedSpace = SpaceUtil.searchSpaceTree(this.form.pdOwnSpId, this.fileData.topSpaceModel)
      this.dirAtt = this.fileData.attributeModelList.find(att => {
        return att.attKeycd === ATTRIBUTE_KEY.PT_FLAG_DIR && att.spaceId === this.form.pdOwnSpId
      })
      this.spaceObjName = this.fileData.objectDataModelList.find(obj => {
        return obj.spaceId === this.form.pdOwnSpId
      }).objName
      // 表示用の面の設定
      switch (this.dirAtt.attValue1) {
        case 1:
          this.firstFace = {name: '上面', code: 3}
          this.secondFace = {name: '下面', code: 4}
          break
        case 2:
          this.firstFace = {name: '右面', code: 1}
          this.secondFace = {name: '左面', code: 2}
          break
        case 3:
          this.firstFace = {name: '前面', code: 5}
          this.secondFace = {name: '背面', code: 6}
          break
        default:
      }
    },
    /** パーツのプレビュー表示 */
    showPartsPreview: function () {
      // 上下(1),左右(2),前後(3)
      switch (this.dirAtt.attValue1) {
        case 1:
          this.textPreviewData.sizeW.size = this.selectedSpace.w
          this.textPreviewData.sizeH.size = this.selectedSpace.d
          break
        case 2:
          this.textPreviewData.sizeW.size = this.selectedSpace.d
          this.textPreviewData.sizeH.size = this.selectedSpace.h
          break
        case 3:
          this.textPreviewData.sizeW.size = this.selectedSpace.w
          this.textPreviewData.sizeH.size = this.selectedSpace.h
          break
        default:
      }
      this.calcPreviewRatio()
      this.previewData.width = this.textPreviewData.sizeW.size * this.previewRatio
      this.previewData.height = this.textPreviewData.sizeH.size * this.previewRatio
      // 寸法テキスト位置
      this.textPreviewData.sizeW.x = this.svgSize / 2
      this.textPreviewData.sizeW.y = (this.svgSize - this.previewData.height) / 2 - 10
      this.textPreviewData.sizeH.x = this.svgSize - (this.svgSize - this.previewData.width) / 2 + 10
      this.textPreviewData.sizeH.y = this.svgSize / 2
    },
    /** 加工のプレビュー表示 */
    onPreview: function () {
      let process = this.selectedProcess
      let space = this.selectedSpace
      let pdX = this.selectedProcess ? process.pdX : this.form.pdX
      let pdY = this.selectedProcess ? process.pdY : this.form.pdY
      let processR = this.selectedProcess ? process.processR : this.form.processR
      let pdOriginal = this.form.cornerType
      // 選択加工があったら頂点をコードに変換
      if (this.selectedProcess && !this.isSetProcess) {
        pdOriginal = Object.keys(CORNER_TYPE)
          .filter(data => CORNER_TYPE[data].label === process.pdOriginal)
          .map(data => { return CORNER_TYPE[data].code })[0]
      }
      // 選択加工があったら対象面をコードに変換
      this.form.faceType = this.selectedProcess && !this.isSetProcess ? this.getfaceTypeCode(this.selectedProcess.pdOwnFaceType) : this.form.faceType
      this.previewData.processX = this.getProcessX(pdOriginal, pdX, space) * this.previewRatio
      this.previewData.processY = this.getProcessY(pdOriginal, pdY, space) * this.previewRatio
      this.previewData.processW = process ? process.pdW * this.previewRatio : this.form.pdW * this.previewRatio
      this.previewData.processW = this.previewData.processW < this.minPreviewProcessSize ? this.minPreviewProcessSize : this.previewData.processW
      if (this.processType === 1) {
        // ○
        this.previewData.processRX = this.previewData.processW / 2
        this.previewData.processRY = this.previewData.processW / 2
        this.previewData.processH = this.previewData.processW
      } else if (this.processType === 2) {
        // □
        this.previewData.processRX = processR != null ? processR * this.previewRatio : 0
        this.previewData.processRY = processR != null ? processR * this.previewRatio : 0
        this.previewData.processH = process ? process.pdH * this.previewRatio : this.form.pdH * this.previewRatio
      }
      this.previewData.processH = this.previewData.processH < this.minPreviewProcessSize ? this.minPreviewProcessSize : this.previewData.processH
    },
    /** 表示用座標に変換 */
    getProcessX: function (pdOriginal, pdX, space) {
      switch (pdOriginal) {
        case CORNER_TYPE.LT.code:
        case CORNER_TYPE.LC.code:
        case CORNER_TYPE.LB.code:
          return pdX
        case CORNER_TYPE.RT.code:
        case CORNER_TYPE.RC.code:
        case CORNER_TYPE.RB.code:
          return this.form.faceType === 1 || this.form.faceType === 2 ? space.d - pdX : space.w - pdX
        case CORNER_TYPE.TC.code:
        case CORNER_TYPE.CC.code:
        case CORNER_TYPE.BC.code:
          return this.form.faceType === 1 || this.form.faceType === 2 ? space.d / 2 - pdX : space.w / 2 - pdX
        default:
          return 0
      }
    },
    getProcessY: function (pdOriginal, pdY, space) {
      switch (pdOriginal) {
        case CORNER_TYPE.LT.code:
        case CORNER_TYPE.TC.code:
        case CORNER_TYPE.RT.code:
          return pdY
        case CORNER_TYPE.LB.code:
        case CORNER_TYPE.BC.code:
        case CORNER_TYPE.RB.code:
          return this.form.faceType === 3 || this.form.faceType === 4 ? space.d - pdY : space.h - pdY
        case CORNER_TYPE.LC.code:
        case CORNER_TYPE.CC.code:
        case CORNER_TYPE.RC.code:
          return this.form.faceType === 3 || this.form.faceType === 4 ? space.d / 2 - pdY : space.h / 2 - pdY
        default:
          return 0
      }
    },
    // 対象面のコード取得
    getfaceTypeCode: function (faceType) {
      switch (faceType) {
        case FACE_TYPE.RIGHT: return 1
        case FACE_TYPE.LEFT: return 2
        case FACE_TYPE.TOP: return 3
        case FACE_TYPE.BOTTOM: return 4
        case FACE_TYPE.FRONT: return 5
        case FACE_TYPE.BACK: return 6
        default: return 0
      }
    },
    /** 縮尺率の計算 */
    calcPreviewRatio: function () {
      if (this.textPreviewData.sizeW.size > this.svgSize * 0.8 || this.textPreviewData.sizeH.size > this.svgSize * 0.8) {
        let widthRatio = this.svgSize / this.textPreviewData.sizeW.size
        let heightRatio = this.svgSize / this.textPreviewData.sizeH.size
        this.previewRatio = widthRatio > heightRatio ? heightRatio * 0.8 : widthRatio * 0.8
      } else {
        this.previewRatio = 0.8
      }
    },
    /** 加工追加・編集 */
    updateProcess: function () {
      let payload = this.form
      payload.spaceJoincd = this.fileData.spaceJoincd
      if (this.selectedProcess) {
        payload.pdX = this.selectedProcess.pdX
        payload.pdY = this.selectedProcess.pdY
        payload.pdZ = this.selectedProcess.pdZ
        payload.pdW = this.selectedProcess.pdW
        payload.pdH = this.selectedProcess.pdH
        payload.pdD = this.selectedProcess.pdD
        payload.processR = this.processType === 2 && this.selectedProcess.processR != null ? this.selectedProcess.processR : 0
      }
      // 貫通の場合
      if (this.isThroughProcess) {
        payload.pdD = -1
      }
      if (!this.selectedProcess) {
        axios.post(API_URL.PLANNING + '/process/add', payload)
          .then(response => {
            this.$refs.loadingModalRef.showModal(false)
            this.showModal()
            this.validateErrorMessages = {}
            this.$emit('setResponseData', response)
          }).catch(error => {
            this.$refs.loadingModalRef.showModal(false)
            this.validateErrorMessages = {}
            Api.handleError(error, this.errorMessage, this.validateErrorMessages)
          })
      } else {
        axios.post(API_URL.PLANNING + '/process/update', payload)
          .then(response => {
            this.$refs.loadingModalRef.showModal(false)
            this.showModal()
            this.validateErrorMessages = {}
            this.$emit('setResponseData', response)
          }).catch(error => {
            this.$refs.loadingModalRef.showModal(false)
            this.validateErrorMessages = {}
            Api.handleError(error, this.errorMessage, this.validateErrorMessages)
          })
      }
    },
    /** 削除確認 */
    confirmDelete: function () {
      if (isNaN(this.form.pdId) || this.form.pdId === '') {
        this.errorMessage.text = '加工を選択してください'
        return
      }
      let modalData = {
        messages: ['本当に削除しますか？'],
        modalType: 'confirm',
        textAlign: 'left',
        onOk: this.deleteProcess
      }
      AppUtil.showModal(modalData)
    },
    /** 加工削除 */
    deleteProcess: function () {
      axios.get(API_URL.PLANNING + '/process/delete/' + this.form.pdId)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          this.showModal()
          this.validateErrorMessages = {}
          this.$emit('setResponseData', response)
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
    },
    clearData: function () {
      this.form = {
        pdId: '',
        faceType: '',
        processId: '',
        cornerType: '',
        pdX: 0,
        pdY: 0,
        pdZ: 0,
        pdW: 0,
        pdH: 0,
        pdD: 0,
        processR: 0
      }
      this.isThroughProcess = false
      this.previewData.processX = ''
      this.previewData.processY = ''
      this.previewData.processW = ''
      this.previewData.processH = ''
      this.errorMessage = { text: '' }
      this.validateErrorMessages = {}
    }
  }
}
</script>
<style lang="scss" scoped>
.faceoption-modal{
  max-height: 100%;
  min-width: 750px;
  max-width: 800px;
}
.main-area {
  max-height: 680px;
  overflow-y: scroll;
}
.data-area{
  min-height: 150px;
  margin: 20px auto;
  li{
    margin-bottom: 20px;
    .label{
      min-width: 150px;
      display: inline-block;
      text-align: left;
    }
    .input{
      min-width: 470px;
      display: inline-block;
      text-align: left;
      label{
        min-width: 150px;
        text-align: left;
        padding: 0 10px;
        input[type="radio"]{
          margin: 0 3px;
        }
      }
    }
    input[type="number"]{
      width: 100px;
    }
    .input-size{
      display: inline-block;
      vertical-align: top;
      padding: 0 5px;
      .check{
        text-align: center;
      }
    }
  }
  .select-process {
    min-width: 200px;
  }
}
.errormessage-area{
  text-align: left;
  padding: 20px 140px;
}
.preview-area{
  margin: auto;
  .face-area{
    display: inline-block;
    .face-name{
      margin-bottom: 20px;
      font-weight: bold;
    }
  }
}
.error_messages{
  margin-left: auto;
  margin-right: auto;
  max-width: 270px;
  min-width: 270px;
}
.error_message {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/planning/modal/FaceOptionModal.vue